<style lang="scss" scope>
.ComponentDOB {
	.flex {
		.v-input {
			.v-input__control {
				.v-text-field__details {
                    display: none;
				}
			}
		}
	}
    .theme--light.v-select.valid_entry .v-select__selections {
        color: #0DB14B;
    }
}

.ComponentDOBErrorMessage {
    .v-text-field__details {
        margin-top: -1.5rem;
        display: block;
    }
}
</style>

<template>
    <v-layout class="ComponentDOB" row wrap>
        <v-flex xs12 sm12 md12 lg12 xl12 v-if="main_label != ''">
            <label for="birth_day" class="d-block mb-0">{{main_label}}</label> <!-- What's your date of birth?-->
        </v-flex>
        <v-flex xs12 sm12 md4 lg4 xl4>
            <v-overflow-btn
                id="birth_day"
                v-model="birth_day"
                label="Day"
                :items="days_of_the_month"
                :error-messages="errors.collect('birth_day')"
                v-validate="'required'" 
                data-vv-name="birth_day" 
                flat
                outline
                :class="{valid_entry: fields.birth_day && fields.birth_day.valid}"
                >
            </v-overflow-btn>
        </v-flex>
        <v-flex xs12 sm12 md4 lg4 xl4>
            <v-overflow-btn
                id="birth_month"
                v-model="birth_month"
                label="Month"
                :items="month_of_the_year"
                :error-messages="errors.collect('birth_month')"
                item-text="text"
                item-value="value"
                v-validate="'required'" 
                data-vv-name="birth_month"
                flat
                outline
                :class="{valid_entry: fields.birth_month && fields.birth_month.valid}"
                ></v-overflow-btn>
        </v-flex>
        <v-flex xs12 sm12 md4 lg4 xl4>
            <v-overflow-btn
                id="birth_year"
                v-model="birth_year"
                label="Year"
                :items="years"
                :error-messages="errors.collect('birth_year')"
                v-validate="'required'" 
                data-vv-name="birth_year"
                flat
                outline
                :class="{ valid_entry: fields.birth_year && fields.birth_year.valid }"
                ></v-overflow-btn>  
        </v-flex>
        <v-flex class="ComponentDOBErrorMessage" xs12 sm12 md12 lg12 xl12 v-if="error_message != ''">
            <div class="v-text-field__details">
                <div class="v-messages theme--light error--text">
                    <div class="v-messages__wrapper">
                        <div class="v-messages__message">
                            {{ error_message }}
                        </div>
                    </div>
                </div>
            </div>
        </v-flex>
    </v-layout>
</template>

<script>

export default {
    $_veeValidate: {
      validator: 'new'
    },
    name: 'DateOfBirth',
    props: {
        "main_label": String
    },
    components: {
        
    },
    data: () => ({
       birthday: {
           valid: null,
           day: "",
           month: "",
           year: "",
           full: "" 
       },
       birth_day: "",
       birth_month: "",
       birth_year: "",
       days_of_the_month: [],
       month_of_the_year: [
            { text:'January', value:'1' },
            { text:'February', value:'2' },
            { text:'March', value:'3' },
            { text:'April', value:'4' },
            { text:'May', value:'5' },
            { text:'June', value:'6' },
            { text:'July', value:'7' },
            { text:'August', value:'8' },
            { text:'September', value:'9' },
            { text:'October', value:'10' },
            { text:'November', value:'11' },
            { text:'December', value:'12' }
        ],
        years: [],
        dictionary: {
            custom: {
                birth_day: {
                    required: () => "Birth day is required to proceed."
                },
                birth_month: {
                    required: () => "Birth month is required to proceed."
                },
                birth_year: {
                    required: () => "Birth year is required to proceed.",
                }
            }
        },
        error_message: ""
    }),
    methods: {
       CreateNumberRange(_start, _end) {
            let _data = [];
            for(var i = _start; i <= _end; i++) {
                if(i < 10) { _data.push("0" + i); } else { _data.push(i); }
            }
            return _data;
       },
       SetInvalidDOB() {
           
       },
       GetDateOfBirth() {
            this.$validator.validateAll().then((result) => { 
                if(result) {
                   if(this.CheckIfUnderaged()) {
                       this.error_message = "All individuals must be over 18 years old to qualify";
                       this.CreateDOB(false);        
                   } else {
                       this.CreateDOB(true);
                   }
                } else {
                   this.GetErrorMessage();
                   this.CreateDOB(false);
                }
            });
            return this.birthday;
       },
       CreateDOB(_valid) {
            this.birthday.valid = _valid;
            this.birthday.year = this.birth_year;
            this.birthday.month = this.birth_month;
            this.birthday.day = this.birth_day;
       },
       GetErrorMessage() {
           this.error_message = this.GetRequiredValidatioErrorMessage();
       },
       GetRequiredValidatioErrorMessage() {
           let _msg = ""; 
           const _birthday = [
               this.fields.birth_day.valid,
               this.fields.birth_month.valid,
               this.fields.birth_year.valid
           ];
           
           if(!_birthday[2]) { _msg = "Birth year is required to proceed." }
           if(!_birthday[1]) { _msg = "Birth month is required to proceed." }
           if(!_birthday[0]) { _msg = "Birth day is required to proceed." }

           return _msg;
       },
       CheckIfUnderaged() {
            let _isunderage = false;
            if((this.birth_year !== "") && (this.birth_month.value !== "") && (this.birth_day !== "")) {
                let _year = new Date().getUTCFullYear();
                let _yob = parseInt(this.birth_year);
                let _age = _year - _yob;
                
                if(_age < 19) {
                    _isunderage = true;
                }
            }
            return _isunderage; 
        },
        ForceFieldInvalid() {
            this.fields.birth_day.valid = false;
            this.fields.birth_month.valid = false;
            this.fields.birth_year.valid = false;
        },
        CustomErrorMessage(_msg) {
            this.birthday.valid = false;
            this.CreateDOB(false); 
            this.error_message = _msg;
        },
        SetDateOfBirth(_year, _month, _day) {
            this.birth_day = parseInt(_day);
            this.birth_month = _month;
            this.birth_year = parseInt(_year);
            this.$validator.validateAll();
        }
    },
    computed: {
        AllFieldsValid: function() {
            let _isvalid = false;
            let fld = this.fields;          
            if(fld.birth_day) {
                if(fld.birth_day.valid && fld.birth_month.valid && fld.birth_year.valid) {
                    _isvalid = true;
                } else {
                    _isvalid = false;
                }
            }  
            return _isvalid;
        },
        IsUnderaged: function() {
            return this.CheckIfUnderaged(); 
        }
    },
    mounted () {
        this.$validator.localize('en', this.dictionary); 
        this.years = this.CreateNumberRange((new Date()).getFullYear() - 50,(new Date()).getFullYear());
        this.days_of_the_month = this.CreateNumberRange(1,31);
    }
}
</script>



